import Vue from 'vue'

const trainingModule = {
  namespaced: true,
  state: {
    tutorials: {}
  },
  mutations: {
    setPagesTutorials: (state, tutorials) => {
      state.tutorials = tutorials
    },
    setPageTutorial: (state, tutorialName) => {
      state.tutorials[tutorialName] = true
    }
  },
  actions: {
    FETCH_PAGES_TUTORIALS_INFO: async ({ state, commit, rootState, rootGetters }) => {
      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/users/pages_tutorials`, {
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.status === 200) {
          commit('setPagesTutorials', response.body.pages_tutorials)
        }
      } catch (e) {
        console.error(e)
        throw new Error(e.statusText)
      }
    },
    SET_PAGE_TUTORIAL_INFO: async ({ state, commit, rootState, rootGetters }, tutorialName) => {
      const body = {
        [tutorialName]: true
      }

      try {
        const response = await Vue.http.patch(
          `${rootGetters.getBackendUrl}/users/pages_tutorials`,
          body,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.status === 200) {
          commit('setPageTutorial', tutorialName)
        }
      } catch (e) {
        console.error(e)
        throw new Error(e.statusText)
      }
    }
  }
}

export default trainingModule



// WEBPACK FOOTER //
// ./src/store/modules/training.js